module.exports = __webpack_public_path__ + "img/9788960170957.48f897d4.jpg";